"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var memoize = require('lodash/memoize');
exports.isFirefox = memoize(function () {
    return /firefox/i.test(navigator.userAgent);
});
exports.isSafari = memoize(function () { return Boolean(window.safari); });



//////////////////
// WEBPACK FOOTER
// ./node_modules/react-dnd-html5-backend/lib/BrowserDetector.js
// module id = 533
// module chunks = 0